<div class="wrapper">
  <h1>{{ seconds }}</h1>
  <h4>{{ 'Timer.SecondsLeft' | translate }}</h4>
  <div class="btn-wrapper" *ngIf="!start">
    <button class="next-button" mat-raised-button color="primary" (click)="startTimer()">{{ 'Timer.Start' | translate }}</button>
    <button class="next-button" mat-raised-button color="accent" (click)="finishTask()">{{ 'Timer.Finish' | translate }}</button>
  </div>
  <div class="btn-wrapper" *ngIf="start">
    <button class="next-button" mat-raised-button color="accent" (click)="failedTask()">{{ 'Timer.Failed' | translate }}</button>
    <button class="next-button" mat-raised-button color="primary" (click)="completeTask()">{{ 'Timer.Completed' | translate }}</button>
  </div>
  <ng-template #failedTaskHelper>
    {{ 'Timer.EveryBodyDrinks' | translate }}
  </ng-template>
  <ng-template #completedTaskHelper>
    {{ 'Timer.SomeBodyShouldDrink' | translate }}
  </ng-template>
</div>